<template>
    <div :class="active ? 'active' : ''" :aria-labelledby="ariaName" @click="handleClick" class="shadow-md rounded-md h-6 w-12 flex flex-row holder relative cursor-pointer my-2">
        <div class="w-1/2 h-full absolute pointer-events-none p-1 transition-all ease-in-out duration-200" :class="active ? 'translate-x-full' : ''">
            <div :class="active ? 'active' : ''" class="toggle shadow-md rounded-md h-full w-full pointer-events-none"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        color: String,
        gradientColor: String,
        active: Boolean,
        backgroundColor: String,
        backgroundGradient: String,
        name: String,
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleClick() {
            if (this.disabled) {
                return;
            }
            this.$emit('update:active', !this.active);
        }
    },
    emits: ['update:active'],
    data: () => ({
        ariaName: null
    }),
    mounted() {
        this.name ? (this.ariaName = this.name) : (this.ariaName = 'button');
    }
};
</script>

<style scoped>
.holder {
    background: #ffffff;
    border-color: v-bind(backgroundColor);
    border-width: 1px;
}
.holder.active {
    background: #4caf50;
}
.toggle {
    background: v-bind(backgroundColor);
}
.toggle.active {
    background: #ffffff;
}
</style>
